import Head from 'next/head'
import {memo} from 'react'
import {CUSTOM_HEAD_THEME, CUSTOM_HEAD_TITLE} from '@/constants'

interface ICustomHeadProps {
    title?: string;
    theme?: string;
    children?: React.ReactNode;
}

const CustomHead = (props:ICustomHeadProps) => {
    const {
        title = CUSTOM_HEAD_TITLE,
        theme = CUSTOM_HEAD_THEME,
        children,
    } = props

    return (
        <Head>
            <title>
                {title}
            </title>
            <meta
                name='viewport'
                content='width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=0,viewport-fit=cover'
            />
            <meta
                name='theme-color'
                content={theme}
            />
            {children}
        </Head>
    )
}

export default memo(CustomHead)
